import { resolved } from 'store/createAction';
import * as svc from 'services/notifications';
import {
  GET_UNREAD_NOTIFICATIONS,
  MARK_READ,
  NEW_NOTIFICATION_RECEIVED,
} from './types';

export const getUnreadNotifications = (user_id) => ({
  type: GET_UNREAD_NOTIFICATIONS,
  payload: {
    promise: svc.getNotifications({
      notifications_seen: '0',
      notifications_user_id: user_id,
      order_by: 'notifications_created_at',
      sort_dir: 'desc',
    }),
  },
});

export const onNewNotification = (payload) => ({
  type: NEW_NOTIFICATION_RECEIVED,
  payload: payload,
});

export const updateNotification = (payload) => ({
  type: MARK_READ,
  payload: {
    promise: svc.updateNotification(payload),
    hash: payload.hash,
  },
});
